import './public-path';

// import { install } from '@/install';

import './styles/index.sass';

import { reviewsSliderObserver } from '@tools/reviews_slider.js';
import { instagramSliderObserver } from '@tools/instagram_slider.js';
import { accordionListener } from '@tools/click_accordion.js';
import { stickyButtonHandler } from '@tools/sticky_button.js';
import { headerHandler } from '@help/header_handler.js';
import { footerObserver } from '@help/footer_handler.js';
import { quoteFormHandler } from '@forms/create_quote.js';
import { appealFormHandler } from '@forms/create_appeal.js';
import { stripeDepositFormHandler } from '@forms/stripe_deposit_pay.js';
import { lazyLoadObserver } from '@tools/lazy_load.js';
import { initReviewsPagination } from '@pages/reviews_page.js';

// app.$mount('#app')

function makeDateInputsFlatpicker() {
  const inputs = document.querySelectorAll('.date-input');
  inputs.forEach(e => {
    flatpickr(e, { dateFormat: 'm-d-Y', minDate: 'today' });
  });
};



function observeLazyImages() {
  const lazyImages = document.querySelectorAll('[data-src]');
  lazyImages.forEach(img => {
    lazyLoadObserver.observe(img);
  });
};

function addQuoteFormHandler(){
  if (document.querySelector('.create-quote-form')) {
    quoteFormHandler();
    // stripeDepositFormHandler();
  }
};

document.addEventListener('DOMContentLoaded', () => {
  headerHandler();
  footerObserver();
  accordionListener(); // can observe?
  reviewsSliderObserver();
  instagramSliderObserver();

  addQuoteFormHandler();
  appealFormHandler();
  stickyButtonHandler();

  makeDateInputsFlatpicker();
  observeLazyImages();
  initReviewsPagination();
});
